var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankingTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.9998L8 10.9998M11 13.9998C12.3968 13.4685 13.7369 12.7985 15 11.9998M11 13.9998V18.9998C11 18.9998 14.03 18.4498 15 16.9998C16.08 15.3798 15 11.9998 15 11.9998M8 10.9998C8.53214 9.61919 9.2022 8.29582 10 7.04976C11.1652 5.18675 12.7876 3.65281 14.713 2.59385C16.6384 1.53489 18.8027 0.986131 21 0.99976C21 3.71976 20.22 8.49976 15 11.9998M8 10.9998H3C3 10.9998 3.55 7.96976 5 6.99976C6.62 5.91976 10 6.99976 10 6.99976M3.5 15.4998C2 16.7598 1.5 20.4998 1.5 20.4998C1.5 20.4998 5.24 19.9998 6.5 18.4998C7.21 17.6598 7.2 16.3698 6.41 15.5898C6.02131 15.2188 5.50929 15.0044 4.97223 14.9878C4.43516 14.9712 3.91088 15.1535 3.5 15.4998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingTech);
export default __webpack_public_path__ + "static/media/bankingTech.1e4936c06d034e762939a545d337d497.svg";
export { ForwardRef as ReactComponent };